var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 300",
    style: {
      enableBackground: "new 0 0 386.4 296"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -1668.6986,
    y1: -354.1465,
    x2: -1623.3271,
    y2: -362.6239,
    gradientTransform: "matrix(-1 0 0 -1 -1312.1401 -214.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AEDC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    style: {
      stopColor: "#63DBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    style: {
      stopColor: "#6BCEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6DC9C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M363.2,130.2c0.6,1.8,0.6,3,0.6,4.2c-1.8,11.3-6.6,19.1-6.6,19.1 c-7.8,11.9-19.7,18.5-24.5,20.9c-5.4-9.6-10.7-18.5-16.1-27.5c3-4.2,6.6-7.8,10.1-11.3c-3.6,0-8.4,0-14.3,2.4 c-9.6,3.6-14.9,10.7-16.7,13.7l-8.4-2.4c0.6-1.8,5.4-22.7,23.9-31c0,0,13.7-6,28.7-2.4c3,0.6,6,1.8,6,1.8c2.4,0.6,4.2,1.8,4.2,1.8 c0.6,1.2,1.8,3,3.6,4.2c1.8,0.6,3.6,1.2,4.2,1.2C359,125.4,361.4,126.6,363.2,130.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129187614559152539840000001070033594847424650_",
    gradientUnits: "userSpaceOnUse",
    x1: -771.3756,
    y1: -374.2401,
    x2: -767.0056,
    y2: -414.5431,
    gradientTransform: "matrix(1 0 0 -1 1091.9929 -214.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BD6C81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.241,
    style: {
      stopColor: "#A36680"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    style: {
      stopColor: "#8C607F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#7F5D7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A5C7E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129187614559152539840000001070033594847424650_)"
    },
    d: "M298.1,135.6l19.7,77 c0,0,14.9-16.1,23.9-42.4L298.1,135.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089568507800490373640000014775721703489578127_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.2,
    y1: 714.5,
    x2: 323.6,
    y2: 714.5,
    gradientTransform: "matrix(1 0 0 1 0 -554)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089568507800490373640000014775721703489578127_)"
    },
    d: "M312.9,58.3h-267 c-5.9,0-10.7,4.8-10.7,10.7v183c0,5.9,4.8,10.7,10.7,10.7h272c3.1,0,5.7-2.5,5.7-5.7V68.9C323.5,63.1,318.8,58.3,312.9,58.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "308,86.4 49.5,86.4 49.5,86.4 49.5,73.6 308,73.6 308,73.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M49.5,95.7v150.2c0,1.6,1.3,3,3,3H305c1.6,0,3-1.3,3-3V97.1c0-0.7-0.6-1.3-1.3-1.3L49.5,95.7 L49.5,95.7z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494948"
    },
    d: "M302.1,80c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1S302.1,78.3,302.1,80z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032632028170375317930000001269413783165048762_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.4,
    y1: 825.15,
    x2: 339.2,
    y2: 825.15,
    gradientTransform: "matrix(1 0 0 1 0 -554)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032632028170375317930000001269413783165048762_)"
    },
    d: "M333.5,262.7H25.2 c-3.2,0-5.8,2.5-5.8,5.7v1.3c0,5.5,4.5,9.9,10.1,9.9l303.2-0.7c5.6,0,6.5-3.8,6.5-9.2v-1.3C339.2,265.2,336.7,262.7,333.5,262.7z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#807C7C",
      enableBackground: "new"
    },
    d: "M186.5,197c60.8,0,110,10.1,110,22.6s-49.2,22.6-110,22.6 s-110-10.1-110-22.6S125.8,197,186.5,197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M107.9,53.5h80v164.3h-80C107.9,217.8,107.9,53.5,107.9,53.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042732275423751408490000006007433799498780559_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.3,
    y1: 944.3857,
    x2: 217.5446,
    y2: 944.3857,
    gradientTransform: "matrix(1 0 0 1 0 -811.3857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#94ACBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    style: {
      stopColor: "#99B0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    style: {
      stopColor: "#A6BDC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    style: {
      stopColor: "#BDD1D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8EAE2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042732275423751408490000006007433799498780559_)"
    },
    d: "M187.3,48.2h30.2v169.6h-30.2V48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M198.9,150.5h49.3v67.3h-49.3V150.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M203.5,159.4v8.4h8.1v-8.4H203.5z M219.8,159.5v8.3h8.1v-8.3H219.8z M236.1,159.5v8.3h8.1v-8.3H236.1z  M203.5,170.9v8.4h8.1v-8.4H203.5z M210.9,182.4l0.8,1.1v-1.1H210.9z M219.8,170.9v8.4h8.1v-8.4H219.8z M236.1,170.9v8.4h8.1v-8.4 H236.1z M203.5,182.4v8.4h8.1v-8.4H203.5z M219.8,182.4v8.4h8.1v-8.4H219.8z M236.1,182.4v8.4h8.1v-8.4H236.1z M203.5,193.7v8.4 h8.1v-8.4H203.5z M210.9,182.4l0.8,1.1v-1.1H210.9z M219.8,193.7v8.4h8.1v-8.4H219.8z M210.9,182.4l0.8,1.1v-1.1H210.9z  M236.1,193.7v8.4h8.1v-8.4H236.1z M203.5,205.2v8.4h8.1v-8.4H203.5z M219.8,205.2v8.4h8.1v-8.4H219.8z M236.1,205.2v8.4h8.1v-8.4 H236.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "205.1,202 203.5,202 203.5,199.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "211.7,211.1 211.7,213.5 203.5,213.5 203.5,205.2 207.4,205.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.5,
    y: 193.7,
    style: {
      fill: "#96CDD5"
    },
    width: 8.1,
    height: 8.4
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "211.7,205.2 211.7,213.5 208.7,213.5 203.5,206.3 203.5,205.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "203.5,179.3 203.5,172.3 208.6,179.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "211.7,183.5 211.7,190.8 203.5,190.8 203.5,182.4 210.9,182.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "219.8,202 219.8,194.7 225.1,202  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "228,205.9 228,213.5 219.8,213.5 219.8,205.2 227.5,205.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "228,159.5 228,167.7 225.4,167.7 219.8,160 219.8,159.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "227.7,170.9 228,170.9 228,171.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "244.2,182.4 244.2,190.8 242.1,190.8 236.1,182.4 236.1,182.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.1,
    y: 159.5,
    style: {
      fill: "#96CDD5"
    },
    width: 8.1,
    height: 8.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.1,
    y: 170.9,
    style: {
      fill: "#96CDD5"
    },
    width: 8.1,
    height: 8.4
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "208.2,159.4 211.7,164.1 211.7,167.7 203.5,167.7 203.5,159.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "211.7,170.9 211.7,179.3 210.4,179.3 204.3,170.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "219.8,179.3 219.8,175.3 222.7,179.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "228,186.5 228,190.8 219.8,190.8 219.8,182.4 225,182.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "228,193.7 228,202 226.9,202 220.8,193.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "236.1,202 236.1,197.6 239.3,202  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "244.2,208.9 244.2,213.5 236.1,213.5 236.1,205.2 241.6,205.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "208.7,167.7 203.5,167.7 203.5,160.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "211.7,171.9 211.7,179.3 204.3,179.3 203.5,178.3 203.5,170.9 211,170.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "211.7,182.4 211.7,189.5 206.6,182.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "225.4,190.8 219.8,190.8 219.8,183.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "228,194.3 228,202 220.8,202 219.8,200.6 219.8,193.7 227.5,193.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "228,205.2 228,211.9 223.1,205.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "241.9,213.5 236.1,213.5 236.1,205.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "219.8,167.7 219.8,159.5 220.7,159.5 226.7,167.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "211.7,159.4 211.7,164.6 207.9,159.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "228,170.9 228,179.3 222.3,179.3 219.8,175.8 219.8,170.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "228,182.4 228,187 224.6,182.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "236.1,190.8 236.1,182.4 237.4,182.4 243.5,190.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "244.2,193.7 244.2,202 238.9,202 236.1,198.2 236.1,193.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "244.2,205.2 244.2,209.4 241.2,205.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "127.6,193.9 127.6,204 115.1,204 115.1,182.6 119.4,182.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "177.3,65.6 177.3,77.4 168.6,65.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "115.1,145.8 115.1,131.7 125.3,145.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.1,
    y: 153.8,
    style: {
      fill: "#96CDD5"
    },
    width: 12.5,
    height: 21.4
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "127.6,182.6 127.6,204 127.4,204 115.1,187.1 115.1,182.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "146.7,175.2 140,175.2 140,165.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "152.1,182.6 152.4,183.1 152.4,204 140,204 140,182.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "167.6,204 164.8,204 164.8,200.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "115.1,65.6 127.6,65.6 127.6,86.9 123.5,86.9 115.1,75.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 65.6,
    style: {
      fill: "#96CDD5"
    },
    width: 12.5,
    height: 21.4
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "140,94.9 152.4,94.9 152.4,116.3 144.9,116.3 140,109.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "150.8,124.4 152.4,124.4 152.4,126.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "177.3,73.3 177.3,86.9 164.8,86.9 164.8,65.6 171.6,65.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.8,
    y: 94.9,
    style: {
      fill: "#96CDD5"
    },
    width: 12.5,
    height: 21.4
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "164.8,124.4 177.3,124.4 177.3,145.8 166.4,145.8 164.8,143.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "177.3,153.8 177.3,160.8 172.1,153.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "115.1,116.3 115.1,100 126.9,116.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "127.6,124.4 127.6,144.9 115.1,127.8 115.1,124.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "140,145.8 140,134.3 148.4,145.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "152.4,153.8 152.4,175.2 149.5,175.2 140,162 140,153.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CDD5"
    },
    points: "177.3,185.6 177.3,204 170.5,204 164.8,196.1 164.8,182.6 174.5,182.6 169.1,175.2  164.8,175.2 164.8,168.5 169.7,175.2 175.1,182.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "117.6,116.3 115.1,116.3 115.1,112.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "123.5,124.4 127.6,130 127.6,145.8 118.4,145.8 115.1,141.3 115.1,124.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "124.2,153.8 127.6,153.8 127.6,158.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "144.9,153.8 152.4,164.1 152.4,175.2 140,175.2 140,153.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "152.4,182.6 152.4,192.7 145.1,182.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "177.3,198.3 177.3,204 164.8,204 164.8,182.6 165.8,182.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "115.1,86.9 115.1,72.5 125.6,86.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "115.1,94.9 127.6,94.9 127.6,116.3 126.3,116.3 115.1,101  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "140,116.3 140,106.7 147,116.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "152.4,124.4 152.4,145.8 147.7,145.8 140,135.1 140,124.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "164.8,145.8 164.8,140.8 168.4,145.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5E1EA"
    },
    points: "177.3,157.9 177.3,175.2 169.7,175.2 175.1,182.6 177.3,182.6 177.3,186.5 174.5,182.6  169.1,175.2 164.8,169.3 164.8,153.8 174.2,153.8  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M164.8,182.6V204h12.5v-21.4H164.8z M140,182.6V204h12.5v-21.4H140z M115.1,182.6V204h12.5v-21.4 H115.1z M164.8,153.8v21.4h12.5v-21.4H164.8z M140,153.8v21.4h12.5v-21.4H140z M115.1,153.8v21.4h12.5v-21.4H115.1z M164.8,124.4 v21.4h12.5v-21.4H164.8z M140,124.4v21.4h12.5v-21.4H140z M140,162v4l6.8,9.3h2.9L140,162z M115.1,124.4v21.4h12.5v-21.4H115.1z  M164.8,94.9v21.4h12.5V94.9H164.8z M140,94.9v21.4h12.5V94.9H140z M115.1,94.9v21.4h12.5V94.9H115.1z M164.8,65.6V87h12.5V65.6 H164.8z M140,65.6V87h12.5V65.6H140z M115.1,65.6v21.3h12.5V65.6H115.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168095912773936353470000014118119937752400281_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.757,
    y1: 1466.1656,
    x2: 282.8881,
    y2: 1564.2338,
    gradientTransform: "matrix(1 0 0 1 0 -1315.3855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168095912773936353470000014118119937752400281_)"
    },
    d: "M254.7,161.3h8.1v6.8h-8.1L254.7,161.3 L254.7,161.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159441222222344454660000002908853155206469565_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.5888,
    y1: 1452.7186,
    x2: 277.582,
    y2: 1567.7354,
    gradientTransform: "matrix(1 0 0 1 0 -1315.3855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159441222222344454660000002908853155206469565_)"
    },
    d: "M254.7,182.5h8.1v8.4h-8.1L254.7,182.5 L254.7,182.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105425149749424103730000005269834626071475638_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.441,
    y1: 1453.1449,
    x2: 274.4336,
    y2: 1568.1602,
    gradientTransform: "matrix(1 0 0 1 0 -1315.3855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105425149749424103730000005269834626071475638_)"
    },
    d: "M254.7,193.9h8.1v8.4h-8.1L254.7,193.9 L254.7,193.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089536296232820551950000017095316558488628908_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.2401,
    y1: 1453.585,
    x2: 271.2325,
    y2: 1568.6017,
    gradientTransform: "matrix(1 0 0 1 0 -1315.3855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089536296232820551950000017095316558488628908_)"
    },
    d: "M254.7,205.5h8.1v8.4h-8.1L254.7,205.5 L254.7,205.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065768472003833612620000011343214414032463773_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.2,
    y1: 856.4357,
    x2: 187.2,
    y2: 856.4357,
    gradientTransform: "matrix(1 0 0 1 0 -811.3857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB1745"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD6B47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065768472003833612620000011343214414032463773_)"
    },
    d: "M104.2,36.5h83v17.1h-83V36.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119106843205013590980000013370676103928278206_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.3,
    y1: 856.4357,
    x2: 222.4414,
    y2: 856.4357,
    gradientTransform: "matrix(1 0 0 1 0 -811.3857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB1745"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD6B47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119106843205013590980000013370676103928278206_)"
    },
    d: "M187.3,36.5h35.1v17.1h-35.1L187.3,36.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087402800029029835390000000755888864536657285_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.2,
    y1: 995.5357,
    x2: 266.8509,
    y2: 995.5357,
    gradientTransform: "matrix(1 0 0 1 0 -811.3857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#94ACBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    style: {
      stopColor: "#99B0BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    style: {
      stopColor: "#A6BDC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    style: {
      stopColor: "#BDD1D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8EAE2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087402800029029835390000000755888864536657285_)"
    },
    d: "M248.2,150.5h18.7v67.3h-18.7V150.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010310755855939658610000005323808349664380311_",
    gradientUnits: "userSpaceOnUse",
    x1: 197,
    y1: 960.2857,
    x2: 248.2,
    y2: 960.2857,
    gradientTransform: "matrix(1 0 0 1 0 -811.3857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB1745"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD6B47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010310755855939658610000005323808349664380311_)"
    },
    d: "M197,145h51.2v7.8H197V145z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049199768963892662800000017782644811075483026_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.2,
    y1: 960.2857,
    x2: 269.8753,
    y2: 960.2857,
    gradientTransform: "matrix(1 0 0 1 0 -811.3857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB1745"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD6B47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049199768963892662800000017782644811075483026_)"
    },
    d: "M248.2,145h21.7v7.8h-21.7V145z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED65D"
    },
    d: "M97.1,193.6l8.5,8.7l-21.1,20.5l-8.5-8.7L97.1,193.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312B30"
    },
    d: "M173.2,128.1c-20.3-20.7-53.8-21.6-74.5-1.2c-20.7,20.3-21.6,53.8-1.2,74.5 c20.3,20.7,53.8,21.6,74.5,1.2C193.1,182.5,193.5,149.1,173.2,128.1z M166.7,197.2c-17.9,17.5-46.5,16.9-63.9-1 c-17.5-17.9-16.9-46.5,1-63.9c17.9-17.5,46.5-16.9,63.9,1C185.1,151.5,184.7,180.1,166.7,197.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179622573265327230850000000273021945211648150_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.3984,
    y1: 146.5826,
    x2: 298.7916,
    y2: 146.5826,
    gradientTransform: "matrix(0.8479 0.5301 -0.5301 0.8479 -2.1091 -93.9552)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179622573265327230850000000273021945211648150_)"
    },
    d: "M167.8,133.4c-17.5-17.9-46.1-18.3-63.9-1 c-17.9,17.5-18.3,46.1-1,63.9c17.5,17.9,46.1,18.3,63.9,1C184.7,180.1,185.1,151.5,167.8,133.4z M164.7,195.2 c-16.7,16.1-43.5,15.9-59.8-0.8s-15.9-43.5,1-59.8c16.7-16.1,43.5-15.9,59.8,0.8S181.7,179.1,164.7,195.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.5,
      fill: "#99DDDA",
      enableBackground: "new"
    },
    cx: 135.3,
    cy: 164.8,
    r: 42.3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312B30"
    },
    d: "M80.7,202.3L45,236.7c-3.8,4-3.6,10.7,0.6,15.1c4,4.2,10.7,4.6,14.9,1 c11.9-11.5,23.8-23.2,35.7-34.4L80.7,202.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M161.7,139.2c-5.4-1.6-15.7-3.8-28.4-1.8 c-15.3,2.6-25.6,10.3-30,13.9c4.4-13.3,15.7-22.6,28.8-24.2C149.4,125.5,160.9,138,161.7,139.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M361.4,112.3H353c-0.6,2.4-2.8,5.3-4.3,7.7c0,1.2,1.8,2.4,3.6,3.3c2.3,1.1,4.3,1.6,5.5,1.6 c1.2-3,1.8-6.6,3-9.6C360.8,114.1,360.8,112.9,361.4,112.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049199124226552977900000017805733783666514103_",
    gradientUnits: "userSpaceOnUse",
    x1: -465.4489,
    y1: -320.4186,
    x2: -445.3784,
    y2: -320.4186,
    gradientTransform: "matrix(-1 0 0 -1 -94.4791 -214.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#082235"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E3150"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049199124226552977900000017805733783666514103_)"
    },
    d: "M359.6,117.7c7.8-2.4,12.5-10.1,10.7-15.5 c-1.8-8.4-15.5-10.1-18.5-7.2c-2.4,1.8-0.6,4.8-0.6,4.8C354.2,105.7,357.2,111.7,359.6,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29EA4"
    },
    d: "M349.4,118.9c1.2,0,2.4,0.6,4.2,0c2.4-0.6,3-1.8,3.6-2.4v-2.4l-2.4-1.8h-0.6l-1.8,0.6 C351.8,114.7,351.2,116.5,349.4,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M360.2,102.8c0.6,0,0.6,0,1.2,0.6c1.8,1.8-0.6,6.6-0.6,6.6l0.6,1.2c0,0,1.8-1.8,3-1.2 c1.2,0.6-1.8,4.2-2.4,4.8c-1.2,0.6-1.2-0.6-1.2-0.6c-0.6,0.6-1.2,2.4-3,3s-3,0.6-4.8,0.6c-3,0-4.8,0-5.4-1.2c-1.2-1.2-0.6-2.4,0-5.4 l1.8-5.4c0-1.2,0-1.2,0.6-2.4c0-1.2,0.6-2.4,1.2-3.6C354.8,101,357.8,101.6,360.2,102.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M323.8,112.3c-1.8,0-3,0.6-4.8,0.6c-0.6,0-1.2,0-1.2,0.6s0.6,1.2,1.2,1.2h4.8 C323.8,114.7,325,113.5,323.8,112.3z M323.8,114.7c-1.8,0-3,0.6-4.8,0.6c-0.6,0.6-0.6,0.6-0.6,1.2c0,0,0.6,0.6,1.2,0.6h4.8 C324.4,117.1,325,115.9,323.8,114.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M324.4,116.5c-1.2,0-3,0.6-4.2,0.6c-0.6,0.6-0.6,0.6-0.6,1.2c0,0,0,0.6,0.6,0.6h4.2 C325,118.3,325,117.7,324.4,116.5z M324.4,110.5h-4.8c-0.6,0-1.2,0.6-1.2,1.2c0,0,0,0.6,0.6,0.6h4.8 C323.8,112.3,324.4,111.7,324.4,110.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M314.2,179.2c3,0.6,6,0.6,6.6-0.6V178h1.8l-1.2-6.6h-1.2c-0.6,0-0.6-0.6-1.2-0.6 c-1.8-0.6-3.6,0.6-3.6,0.6C314.8,173.8,314.8,176.2,314.2,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29EA4"
    },
    d: "M314.2,178.6c1.8,0.6,3.6,1.2,4.8,0.6c0.6-0.6,0-1.8,0-1.8c1.2-1.8,0-3,0-3c0.6-0.6,0-1.8,0-1.8 v-1.8c-1.8-0.6-3.6,0.6-3.6,0.6C314.8,173.8,314.8,176.2,314.2,178.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M317.8,173.2h-6c-0.6-0.6-1.2,0-1.2,0.6s0.6,1.2,1.2,1.2c1.8,0.6,3.6,0.6,5.4,0.6 C317.2,175.6,318.4,174.4,317.8,173.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M317.2,175c-1.8,0.6-3.6,0.6-5.4,0.6c-0.6,0-1.2,0.6-1.2,1.2c0,0.6,0.6,1.2,1.2,1.2h5.4 C317.2,178,318.4,176.8,317.2,175z M317.8,178H313c-0.6,0.6-0.6,0.6-0.6,1.2s0,1.2,0.6,1.2h4.8C317.8,179.8,318.4,179.2,317.8,178z  M318.4,170.2c-1.8-0.6-3.6-0.6-5.4-0.6c-0.6,0-1.2,0.6-1.2,1.2c-0.6,0.6,0,1.2,0.6,1.2c1.8,0,3.6,0.6,5.4,0.6 C317.8,172.6,318.4,172,318.4,170.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121976655311536587490000009392753363631110324_",
    gradientUnits: "userSpaceOnUse",
    x1: -1630.3392,
    y1: -387.9151,
    x2: -1684.6895,
    y2: -358.9968,
    gradientTransform: "matrix(-1 0 0 -1 -1312.1401 -214.7244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    style: {
      stopColor: "#6BCEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    style: {
      stopColor: "#63DBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5AEDC8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121976655311536587490000009392753363631110324_)"
    },
    d: "M333.9,181.6c-5.4-0.6-10.1-1.2-13.1-1.8 v-9.6c2.4-0.6,6.6-1.2,12.5-2.4c7.8-1.8,11.3-2.4,13.7-4.8c3-2.4,3.6-5.4,4.2-7.8c2.4-3.6,5.4-9.6,6.6-17.3c1.2-5.4,0.6-9.6,0-13.1 c1.8,1.2,3.6,3,6,5.4c7.8,9,9.6,22.7,5.4,34c-1.2,3.6-4.2,11.3-11.9,15.5C351.8,182.8,346.5,182.2,333.9,181.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2E5EA0"
    },
    points: "187.4,47.8 331.8,47.8 332,129.7 215.3,129.7 209.2,144 202.6,129.7 187.4,129.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M316.3,70.7c1.4,0,2.4-1,2.4-2.4s-1-2.4-2.4-2.4l-113.2-0.2l0,0c-1.4,0-2.4,1-2.4,2.4 s1,2.4,2.4,2.4L316.3,70.7L316.3,70.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M316.3,85.3c1.4,0,2.4-1,2.4-2.4s-1-2.4-2.4-2.4l-113.2-0.2l0,0c-1.4,0-2.4,1-2.4,2.4 s1,2.4,2.4,2.4L316.3,85.3L316.3,85.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M316.3,100.2c1.4,0,2.4-1,2.4-2.4s-1-2.4-2.4-2.4l-113.2-0.2l0,0c-1.4,0-2.4,1-2.4,2.4 s1,2.4,2.4,2.4L316.3,100.2L316.3,100.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.46c2bc43.svg";
export { ForwardRef as ReactComponent };